export default __webpack_public_path__ + "static/media/premium.1cabf28b.svg";